<script lang="ts">
	import type { PageData } from './$types';
	import { page } from '$app/stores';
	import { getMapLayoutContext } from '$lib/components/map/map-layout-context';
	import FiltersPanel from '$lib/components/pois/filters/FiltersPanel.svelte';
	import { ROUTE_SEARCH } from '$lib/constants/route';
	import { getSearchParamsStore, gotoWithParams } from '$lib/services/urls/searchParams';

	export let data: PageData;
	$: ({ partnersLinks } = data);

	const {
		poiMarkerWithDetailsEnabled,
		handlePoiMarkerWithDetailsByFilterChange,
		onAccommodationSelectDates,
		onAccommodationClearDates,
		onMichelinSelectionChange,
	} = getMapLayoutContext();

	const searchParams = getSearchParamsStore();
</script>

<FiltersPanel
	{partnersLinks}
	withPartner={$page.data.hasPartnerAdinmap}
	detailedView={$poiMarkerWithDetailsEnabled}
	on:goBack={() => {
		// DO NOT USE goBackWithFallback here because we want the filters to persist
		gotoWithParams(ROUTE_SEARCH, $searchParams);
	}}
	on:selectDates={({ detail }) => {
		onAccommodationSelectDates(detail);
	}}
	on:clearDates={() => {
		onAccommodationClearDates();
	}}
	on:michelinSelectionChange={({ detail: isOnlyMichelin }) => {
		onMichelinSelectionChange(isOnlyMichelin);
	}}
	on:poiFilterChange={handlePoiMarkerWithDetailsByFilterChange}
/>
